import clsx from "clsx";

import { PRICING_PLANS } from "features/subscriptions/constants";

import { typedObjectEntries } from "common/helpers/utils";

import type { Dispatch, SetStateAction } from "react";

interface SubscriptionTypeCardsProps {
  subscriptionType: keyof typeof PRICING_PLANS;
  setSubscriptionType: Dispatch<SetStateAction<keyof typeof PRICING_PLANS>>;
}

export default function SubscriptionTypeCards({
  subscriptionType,
  setSubscriptionType,
}: SubscriptionTypeCardsProps) {
  return (
    <div className="flex overflow-y-auto lg:flex-col gap-3">
      {typedObjectEntries(PRICING_PLANS).map(
        ([key, { name, description, gradientIcon: Icon }]) => {
          const isSelected = key === subscriptionType;

          return (
            <button
              key={key}
              className={clsx(
                "flex border rounded-3xl gap-x-2 lg:gap-x-2.5 p-3 transition-colors",
                isSelected
                  ? "bg-purple-50 border-purple-500"
                  : "bg-white border-black-200 hover:bg-black-100",
              )}
              type="button"
              onClick={() => setSubscriptionType(key)}
            >
              <Icon />

              <div className="flex flex-col gap-y-0.5">
                <h3 className="text-sm-bold text-left">{name}</h3>
                <p className="text-xs-medium text-left text-black-500 max-lg:hidden">
                  {description}
                </p>
              </div>
            </button>
          );
        },
      )}
    </div>
  );
}
